import React from "react";
import { NavLink as RouteLink } from "react-router";

const NavLink = React.forwardRef<HTMLAnchorElement, any>((props, ref) => (
  <RouteLink
    {...props}
    to={props.to}
    ref={ref}
    className={({ isActive }: { isActive: boolean }) =>
      [props.className, isActive ? "Mui-selected" : ""].filter(Boolean).join(" ")
    }
  />
));

NavLink.displayName = "NavLink";

export default React.memo(NavLink);
